import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { AppProps } from 'next/app';
import React, { useEffect, useMemo, useState } from 'react';
import GlobalErrorHandler from '../components/GlobalErrorHandler';
import EnvironmentContextProvider from '../lib/contexts/environmentContext';
import './styles/app.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import '@jexo/pijen/dist/index.css';
import '@atlaskit/css-reset/dist/bundle.css';

interface AppPropsWithJwt extends AppProps {
    jwt?: string;
    roadmapOnly?: boolean;
    nonce?: string;
}

const App = ({ Component, pageProps, nonce }: AppPropsWithJwt) => {
    const myCache = useMemo(() => createCache({ key: 'app-style-cache', nonce: nonce ?? '' }), [nonce]);
    return (
        <CacheProvider value={myCache}>
            <EnvironmentContextProvider>
                <GlobalErrorHandler>
                    <Component {...pageProps} />
                </GlobalErrorHandler>
            </EnvironmentContextProvider>
        </CacheProvider>
    );
};

const WithPlatformAdapter = (props) => {
    const [isPlatformAdapterReady, setIsPlatformAdapterReady] = useState(false);
    useEffect(() => {
        (async () => {
            const { createPlatformAdapter } = await import('../platform/PlatformAdapter');
            const platformAdapter = await createPlatformAdapter();
            window.PlatformAdapter = platformAdapter;
            setIsPlatformAdapterReady(true);
        })();
    }, []);

    return isPlatformAdapterReady ? <App {...props} /> : null;
};

export default WithPlatformAdapter;
